Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.LineScaleMode = module.exports.default = {
	HORIZONTAL: "horizontal",
	NONE: "none",
	NORMAL: "normal",
	VERTICAL: "vertical"
};